import mutations from "./mutation_types.js";
import Vue from "vue";

export default {
    [mutations.SET_CONTRACTOR_DATA](state, contractorData) {
        Vue.set(state.contractorsData, contractorData.index, contractorData.data);
    },
    [mutations.REMOVE_CONTRACTOR_DATA](state, index) {
        state.contractorsData.splice(index, 1);
    },
    [mutations.SELECT_OPERATION](state, id) {
        let index = state.contractorHistory.selectedOperations.findIndex(x => x == id);
        if(index < 0) state.contractorHistory.selectedOperations.push(id);
    },
    [mutations.REMOVE_OPERATION](state, id) {
        let index = state.contractorHistory.selectedOperations.findIndex(x => x == id);
        if(index >= 0) state.contractorHistory.selectedOperations.splice(index, 1);
    },
    [mutations.SELECT_DOCUMENT](state, id) {
        let index = state.contractorHistory.selectedDocuments.findIndex(x => x == id);
        if(index < 0) state.contractorHistory.selectedDocuments.push(id);
    },
    [mutations.REMOVE_DOCUMENT](state, id) {
        let index = state.contractorHistory.selectedDocuments.findIndex(x => x == id);
        if(index >= 0) state.contractorHistory.selectedDocuments.splice(index, 1);
    },

    [mutations.ADD_SELECTED](state, selected) {
        let index = state.contractorHistory.selected.findIndex(
            selectable => { return (selectable.id === selected.id && selectable.type === selected.type) }
        );
        if(index >= 0) {
            state.contractorHistory.selected[index] = selected
        } else {
            state.contractorHistory.selected.push(selected);
        }
    },
    [mutations.REMOVE_SELECTED](state, selected) {
        let index = state.contractorHistory.selected.findIndex(
            selectable => { return (selectable.id === selected.id && selectable.type === selected.type) }
        );
        if(index >= 0) {
            state.contractorHistory.selected.splice(index, 1);
        }
    },
    [mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS](state, options /* {index: 1, params: {page: 1, per_page, 20}} */) {
        let params = state.contractorsDataGETParams[options.index] ? state.contractorsDataGETParams[options.index] : {};
        params = Object.assign(params, options.params);
        Vue.set(state.contractorsDataGETParams, options.index, params);
    },
    [mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM](state, options /* {index: 1, param: 'name'} */) {
        let params = state.contractorsDataGETParams[options.index] ? state.contractorsDataGETParams[options.index] : {};
        delete params[options.param];
        Vue.set(state.contractorsDataGETParams, options.index, params);
    },
}